<template>
  <div class="grid-panel">
    <div v-if="panelHeader" class="grid-panel-header">
      <span v-dompurify-html="panelHeader"></span>
    </div>
    <div v-if="panelTitle" class="panel-title" v-dompurify-html="panelTitle"></div>
    <div class="content-container">
      <v-overlay
        absolute
        opacity=1
        :value="loading"
        color="var(--panel-background)"
      >
        <v-progress-circular
            indeterminate
            color="var(--primary-btn-bg-color)"
            size="32"
        ></v-progress-circular>
      </v-overlay>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'grid-panel',
  props: {
    panelTitle: {
      type: String,
      default: ''
    },
    panelHeader: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-panel {
  font-family: var(--font-family);
  height: 100%;
  border-radius: var(--border-radius);
  background-color: var(--panel-background);
  overflow: hidden;
  
  .grid-panel-header {
    height: 40px;
    padding: 0 20px;
    color: var(--text-color);
    font-weight: bold;
    font-size: 16px;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .panel-title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: var(--text-color);
    padding-top: 16px;
  }
  .content-container {
    position: relative;
    height: calc(100% - 45px); // 45 header height
    background-color: var(--panel-background);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow: hidden;

    .chart-container {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
